(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cn-contact"] && !Shopify.designMode) return;
  try {
    
function chefNicheInquiry() {
  const form = document.querySelector('#ChefNicheContact');
  if (!form || form.dataset.cnReady) return;
  form.dataset.cnReady = 'true';
  const params = new URLSearchParams(location.search);
  const allowed = ['VP600', 'BMDGF5'];
  const model = allowed.includes(params.get('model')) ? params.get('model') : '';
  const topic = document.querySelector('#cn-topic');
  if (topic && params.get('inquiry') === 'supplier') topic.value = 'Supplier/manufacturer partnership';
  if (topic && params.get('inquiry') === 'general') topic.value = 'General inquiry';
  const success = document.querySelector('[data-cn-contact-success]');
  if (success) {
    success.focus();
    try {
      const pending = JSON.parse(sessionStorage.getItem('cn_quote_pending') || 'null');
      if (pending && allowed.includes(pending.model) && Date.now() - pending.time < 3600000) {
        sessionStorage.removeItem('cn_quote_pending');
        const key = 'cn_quote_sent_' + pending.id;
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, '1');
          let emitted = false;
          const publish = () => {
            if (emitted) return;
            if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
            emitted = true;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event:'cn_quote_request_success',event_id:pending.id,product_model:pending.model,lead_type:'delivered_quote',currency:'CAD'});
            if (typeof gtag === 'function') {
              gtag('event', 'conversion', {
                'send_to': 'AW-18469252634/r9BLCJimkYYdEJrc6eZE',
                'transaction_id': pending.id
              });
            }
            document.removeEventListener('visitorConsentCollected', publish);
          };
          publish();
          document.addEventListener('visitorConsentCollected', publish, {once:true});
        }
      }
    } catch (_) {}
    return;
  }
  if (!model) return;
  document.querySelector('#cn-quote-context').hidden = false;
  document.querySelector('#cn-quote-fields').hidden = false;
  document.querySelector('#cn-model').value = model;
  const submitButton = form.querySelector('button[type="submit"]');
  submitButton.textContent = submitButton.dataset.quoteSubmit;
  form.closest('.cn-contact').classList.add('cn-quote-mode');
  document.querySelector('#cn-company').required = true;
  document.querySelector('label[for="cn-company"] span')?.remove();
  document.querySelector('#cn-phone').required = true;
  document.querySelector('#cn-postal').required = true;
  document.querySelector('#cn-message').required = false;
  const messageLabel = document.querySelector('label[for="cn-message"]');
  messageLabel.textContent = messageLabel.dataset.quoteLabel;
  form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    try {
      let pending = JSON.parse(sessionStorage.getItem('cn_quote_pending') || 'null');
      if (!pending || pending.model !== model || Date.now()-pending.time > 3600000) pending = {id:crypto.randomUUID(),model,time:Date.now()};
      document.querySelector('#cn-quote-id').value = pending.id;
      sessionStorage.setItem('cn_quote_pending', JSON.stringify(pending));
    } catch (_) {}
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chefNicheInquiry); else chefNicheInquiry();
document.addEventListener('shopify:section:load', chefNicheInquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
